import React, { useMemo } from 'react';

const PLACEHOLDER_COLORS = ['#ffc964', '#d65952', '#7ec28a', '#6ba1cf', '#a089f1', '#c5cdd4'];

export default function ThumbnailPlaceholder() {
  const randomColor = useMemo(() => {
    return PLACEHOLDER_COLORS[Math.floor(Math.random() * PLACEHOLDER_COLORS.length)];
  }, []);

  return (
    <div
      className="image-placeholder"
      style={{ backgroundColor: randomColor }}
    />
  );
}
